var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"app-itms-main"},[_c('el-scrollbar',{staticClass:"app-main-scrollbar",staticStyle:{"height":"calc(100vh - 144px)"},attrs:{"wrap-class":"app-scrollbar-wrapper"}},[_c('keep-alive',{attrs:{"max":_vm.maxPageNumber,"include":_vm.keepAliveComponents}},[(_vm.isRouterAlive)?_c('router-view',{key:_vm.key}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }